/** Shared Favorite Dances copy — import here to keep prompt, sheet, and entry in sync. */
export const FD_VOTE_TITLE = "Who made your night?";
export const FAVORITE_DANCES_NOTIFICATIONS = {
  promptReady: FD_VOTE_TITLE,
};
export const FD_WELCOME_TITLE = "Favorite dance people";
export const FD_WELCOME_BODY =
  "Pick up to 3 partners you loved dancing with. Each one gets an anonymous thank-you — your name stays private.";
export const FD_WELCOME_SAFETY =
  "After you've picked 5 partners across socials, we'll flag events on your feed when they're going out.";
export const FD_WELCOME_EXPERIMENT =
  "Always private, always positive, always your choice each event.";
export const FD_WELCOME_EVENT_STATS = "{n} thank-yous shared so far tonight";
export const FD_WELCOME_OPT_IN = "I'm in";
export const FD_WELCOME_DECLINE = "Not tonight";
export const FD_DECLINE_THANKS =
  "No worries — enjoy the floor tonight. You can always play after a future social.";
export const FD_RESULTS_DONE = "Got it";
export const FD_RESULTS_TITLE = "❤️ Thank-you sent";
export const FD_RESULTS_SENT_LINE_ONE = "Your appreciation was sent anonymously.";
export const FD_RESULTS_SENT_LINE_MANY = "Your appreciations were sent anonymously.";
export const FD_RESULTS_SENT_PRIVACY = "They won't know it was you.";
export const FD_RESULTS_SURPRISE_TITLE = "✨ A nice surprise";
export const FD_RESULTS_RECEIVED_ONE = "Someone picked you tonight.";
export const FD_RESULTS_RECEIVED_MANY = "{n} people picked you tonight.";
export const FD_RESULTS_RECEIVED_CONTENT = "You left a great impression.";
export const FD_RESULTS_COMMUNITY_TITLE = "🤝 Community";
export const FD_RESULTS_COMMUNITY_COUNT = "{n} thank-yous were shared tonight.";
export const FD_RESULTS_COMMUNITY_CONTENT =
  "Small moments like these make the dance community more welcoming.";
export const FD_RESULTS_GOAL_TITLE = "🌟 Next goal";
export const FD_RESULTS_GOAL_SUBTITLE =
  "Thank {remaining} more people at future socials to unlock Highlights.";
export const FD_RESULTS_GOAL_CONTENT =
  "See where familiar faces you've appreciated will be dancing next.";
export const FD_RESULTS_GOAL_UNLOCKED_TITLE = "🌟 Highlights";
export const FD_RESULTS_GOAL_UNLOCKED_SUBTITLE = "Highlights are on.";
export const FD_RESULTS_GOAL_UNLOCKED_CONTENT = FD_RESULTS_GOAL_CONTENT;
export const FD_VOTE_HINT =
  "Tap anyone who stood out. It's private — they'll only know someone picked them, not who.";
export const FD_VOTE_FOOTER = "Your picks are never shown to anyone.";
export const MIN_PICKS = 1;
export const MAX_PICKS = 3;
export const EVENT_SIGNAL_MIN_APPRECIATIONS = 5;
export const FD_VOTE_SIGNAL_HINT =
  "After {n} people share, everyone here sees tonight's count. Your picks stay private.";
export const FD_VOTE_CTA = "Send thank-yous";
export const FD_VOTE_SKIP = "Skip for tonight";
export const FD_EVENT_CTA = "Pick favorite dances 💛";
export const FD_FEED_VOTE_CTA = "Who did you love dancing with?";

export const FD_OPT_IN_TITLE = "Play Favorite Dances tonight?";
export const FD_OPT_IN_BODY = FD_WELCOME_BODY;
export const FD_OPT_IN_ACCEPT = FD_WELCOME_OPT_IN;
export const FD_OPT_IN_DECLINE = FD_WELCOME_DECLINE;

export const FD_FIRST_EXPOSURE_KEY = "ln_fd_first_exposure_v1";
export const FD_FIRST_EXPOSURE_BODY =
  "Favorite Dances is a post-social game. Pick up to 3 partners you loved dancing with — they get anonymous appreciation, and the app learns which nights your people are going to. Private, positive-only, opt-in every event.";
export const FD_FIRST_EXPOSURE_BIDIRECTIONAL =
  "I'm in means you can pick partners and be picked too.";

export const FD_HOW_IT_WORKS_TITLE = "How Favorite Dances works";
export const FD_HOW_IT_WORKS_PLAY =
  "Each social, you choose to play. Check-in asks — I'm in or Not tonight. Playing means you can pick and be picked.";
export const FD_HOW_IT_WORKS_PICKS =
  "After the night, pick up to 3. Partners you pick get an anonymous thank-you. They never see who — no names, no counts, no leaderboards.";
export const FD_HOW_IT_WORKS_FEED =
  "Your feed gets smarter. Once you've played a few socials, events start getting highlighted when people you've picked are going. No names on the card — tap through to see the guest list.";

export const FD_HOST_KIT_BODY =
  "We play Favorite Dances at our socials — after the party, you can privately pick up to 3 partners you loved dancing with. Picks stay private, positive-only, and opt-in every night. Join in from the vote prompt if you'd like to play.";
export const FD_HOST_KIT_STORY_HEADLINE = "We play Favorite Dances at our socials";
export const FD_HOST_KIT_STORY_SUBLINE = "Private picks. Positive-only. Opt in every night.";

export const FD_CREW_BENEFIT_HINT =
  "Picks help us highlight events when partners you've chosen RSVP somewhere.";
export const FD_CONFIRMATION_DONE = "Got it";
export const FD_EMPTY_ATTENDEES = "You're the only one checked in so far.";
export const FD_EMPTY_ATTENDEES_HINT = "More dancers will appear here as they check in.";
export const FD_CLOSED_TITLE = "Voting is closed for this night.";
export const FD_CLOSED_HINT =
  "Voting opens when the social starts and stays open for 24 hours after it ends.";
export const FD_LOAD_ERROR_TITLE = "Couldn't load dancers";

export const CREW_NUDGE_MIN_DISTINCT = 5;
export const CREW_NUDGE_COPY = "💃 People you love dancing with are going";
export const CREW_NUDGE_TOOLTIP_KEY = "ln_crew_card_tooltip_v1";
export const CREW_NUDGE_TOOLTIP_COPY =
  "This appears when partners you've picked RSVP somewhere";

export function isOccurrenceWithinEventVoteRange(occurrenceDate, now = new Date()) {
  if (!occurrenceDate) return false;
  const today = now.toISOString().slice(0, 10);
  const yesterday = new Date(now.getTime() - 86400000).toISOString().slice(0, 10);
  return occurrenceDate === today || occurrenceDate === yesterday;
}

export function readFirstExposureSeen() {
  try {
    return Boolean(localStorage.getItem(FD_FIRST_EXPOSURE_KEY));
  } catch {
    return true;
  }
}

export function markFirstExposureSeen() {
  try {
    localStorage.setItem(FD_FIRST_EXPOSURE_KEY, "1");
  } catch {
    /* private browsing */
  }
}

export function fdWelcomeEventStats(n) {
  const count = Number(n) || 0;
  return FD_WELCOME_EVENT_STATS.replace("{n}", String(count));
}

export function fdResultsSentBlock(myPickCount) {
  const count = Number(myPickCount) || 0;
  return {
    title: FD_RESULTS_TITLE,
    subtitle: count === 1 ? FD_RESULTS_SENT_LINE_ONE : FD_RESULTS_SENT_LINE_MANY,
    content: FD_RESULTS_SENT_PRIVACY,
  };
}

export function fdResultsSurpriseBlock(n) {
  const count = Number(n) || 0;
  if (count < 1) return null;
  return {
    title: FD_RESULTS_SURPRISE_TITLE,
    subtitle:
      count === 1
        ? FD_RESULTS_RECEIVED_ONE
        : FD_RESULTS_RECEIVED_MANY.replace("{n}", String(count)),
    content: FD_RESULTS_RECEIVED_CONTENT,
  };
}

export function fdResultsCommunityBlock(eventTotalPicks, min = EVENT_SIGNAL_MIN_APPRECIATIONS) {
  const total = Number(eventTotalPicks) || 0;
  const threshold = Number(min) || EVENT_SIGNAL_MIN_APPRECIATIONS;
  if (total < threshold) return null;
  return {
    title: FD_RESULTS_COMMUNITY_TITLE,
    subtitle: FD_RESULTS_COMMUNITY_COUNT.replace("{n}", String(total)),
    content: FD_RESULTS_COMMUNITY_CONTENT,
  };
}

export function fdResultsProgressBlock(crewDistinct, min = CREW_NUDGE_MIN_DISTINCT) {
  const progress = fdResultsFeedProgress(crewDistinct, min);
  if (progress.remaining <= 0) {
    return {
      title: FD_RESULTS_GOAL_UNLOCKED_TITLE,
      subtitle: FD_RESULTS_GOAL_UNLOCKED_SUBTITLE,
      content: FD_RESULTS_GOAL_UNLOCKED_CONTENT,
    };
  }
  return {
    title: FD_RESULTS_GOAL_TITLE,
    subtitle: FD_RESULTS_GOAL_SUBTITLE.replace("{remaining}", String(progress.remaining)),
    content: FD_RESULTS_GOAL_CONTENT,
  };
}

export function fdResultsFeedProgress(current, min = CREW_NUDGE_MIN_DISTINCT) {
  const count = Number(current) || 0;
  const threshold = Number(min) || CREW_NUDGE_MIN_DISTINCT;
  return { current: count, min: threshold, remaining: Math.max(0, threshold - count) };
}

export function fdPickCountLabel(selected) {
  const count = Number(selected) || 0;
  if (count === 1) return "1 picked";
  return `${count} picked`;
}

export function fdVoteSignalHint(n = EVENT_SIGNAL_MIN_APPRECIATIONS) {
  return FD_VOTE_SIGNAL_HINT.replace("{n}", String(n));
}

export function fdAttendeeTileLabel(name, { selected, atMaxPicks }) {
  if (selected) return `${name}, selected`;
  if (atMaxPicks) {
    return `${name}, maximum picks reached — deselect someone to choose them`;
  }
  return `${name}, not selected`;
}
